// adminApi.js
import axios from "axios";

const FRANCHISE_ADMIN_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/franchises`;

const apiClient = axios.create({
  baseURL: FRANCHISE_ADMIN_API_SERVICE,
  withCredentials: true,
});

const franchiseAdminAPI = {
  saveFranchises: (payload) => apiClient.post("/addFranchises", payload),

  getLocationsByCompanyName: (companyName) => {
    return apiClient.get(`/locations?companyName=${companyName}`);
  },

  getFranchises1List: () => apiClient.get("/listOffa1"),

  getFranchises1ByPagination: (page, pageSize, sortedColumn, sortOrder) =>
    apiClient.get("/pageOffa1", {
      params: { page, pageSize, sortedColumn, sortOrder },
    }),

  getFranchises2: (id) => apiClient.get(`/fa2/${id}`),

  getFranchise2ByPagination: (
    parentId,
    page,
    pageSize,
    sortedColumn,
    sortOrder,
  ) =>
    apiClient.get(`/pageOffa2/${parentId}`, {
      params: { page, pageSize, sortedColumn, sortOrder },
    }),

  setFranchisePassword: (payload) => apiClient.put("/set-password", payload),
setFranchisePasswordByEmail: (payload) => apiClient.put("/setPasswordByEmail", payload),
    setFranchiseCountry: (payload) => apiClient.put("/set-country", payload),

  loginFranchise: (payload) => apiClient.post("/login", payload),

  getFranchiseDetailsByEmail: (email) =>
    apiClient.get("/getFranchiseDetails", {
      params: { email },
    }),

  getFranchisesByEmail(email, page, pageSize, sortedColumn, sortOrder) {
    return apiClient.get("/franchisesByEmail", {
      params: { email, page, pageSize, sortedColumn, sortOrder },
    });
  },

  addCustomers: (payload) => apiClient.post("/addCustomers", payload),

  getFranchises2List: () => apiClient.get("/listOffa2"),

  getAllCustomers:(id, page, pageSize) => {
    return apiClient.get(`/${id}/referral-codes`, {
      params: { page, pageSize },
    });
  },

  getFrymeDetailsByEmail: (email) =>  apiClient.get("/fryme-details", {
    params: { email },
  }),

  getCountOfFranchises: () => apiClient.get("/count"),

  getCountOfFranchisesByEmail: (email) => apiClient.get("/countChildren", {
    params: { email }
  }),

   getFranchiseDetailsByReferralCode: (referralCode) =>
    apiClient.get("/getFranchiseDetailsByReferralCode", {
      params: { referralCode },
    }),
};

export default franchiseAdminAPI;
